module.exports = __webpack_public_path__ + "public/adminIcons/listSetting.svg?93c69ed5";